// extracted by mini-css-extract-plugin
export default {"AddResourceHeader":"AddResourceHeader_AddResourceHeader__Np6Ao","AddResourceHeader__Img":"AddResourceHeader_AddResourceHeader__Img__IY3jH"};